/* eslint-disable no-console */

//import { register } from 'register-service-worker'
 // service worker
import { register } from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready () {
      console.log(
        'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB'
      )
    },
    // registered (registration) {
    //   console.log('ServiceWorker registration successful with scope: ', registration.scope);
    //   console.log('Service worker has been registered.')
    // },
    cached () {
      console.log('Content has been cached for offline use.')
    },
    // updatefound () {
    //   console.log('New content is downloading.')
    // },
    updated (registration) {
        console.log('New content is available! We\'ll show a refresh button for the user to click on and refresh')
        console.log(registration)
        document.dispatchEvent(new CustomEvent('swUpdated', {detail: registration}))
    },
    offline (registration) {
        console.log('No internet connection found. App is running in offline mode.')
        document.dispatchEvent(new CustomEvent('swOffline', {detail: registration}))
    },
    error (error) {
      console.error('Error during service worker registration:', error)
    }
  })
 //import localForage = require("localforage");
 // navigator.serviceWorker.importScripts('localforage.min.js')

   if (window.location.protocol == 'http:') {

              // console.log("you are accessing us via "
              //     +  "an insecure protocol (HTTP). "
              //     + "Redirecting you to HTTPS.");

              window.location.href =
                  window.location.href.replace(
                             'http:', 'https:');

    }
    else if
        (window.location.protocol == "https:") {
          //  console.log("you are accessing us via"
            //    + " our secure HTTPS protocol.");
    }

   // if(window.location.protocol !== "https:"){
   //     window.location.href = 'https://mobile.innity.com.my/login';
   //  }

  let refreshing
  navigator.serviceWorker.addEventListener("controllerchange", e=>{
    if (refreshing) return
    window.location.reload()
    refreshing = true
  })
}
// if (process.env.NODE_ENV === 'production') {
//     register(`${process.env.BASE_URL}service-worker.js`, {
//         ready () {
//             console.log(
//                 'App is being served from cache by a service worker.\n' +
//                 'For more details, visit https://goo.gl/AFskqB'
//             )
//         },
//         cached () {
//             console.log('Content has been cached for offline use.')
//         },
//         updated (registration) {
//             console.log('New content is available! We\'ll show a refresh button for the user to click on and refresh')
//             console.log(registration)
//             document.dispatchEvent(new CustomEvent('swUpdated', {detail: registration}))
//         },
//         offline (registration) {
//             console.log('No internet connection found. App is running in offline mode.')
//             document.dispatchEvent(new CustomEvent('swOffline', {detail: registration}))
//         },
//         error (error) {
//             console.error('Error during service worker registration:', error)
//         }
//     })
// }
